import styled from 'styled-components'
import IconButton from '../../icon-button'

export const Button = styled(IconButton)`
    border-radius: inherit;
`
